<template>
  <div id="app">
    <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div class="title_all" style="margin-bottom: 0">
                    <div class="title_left">过刊目录</div>
                    <div class="clearfix"></div>
                  </div>
                  <dlistnumList :isgzh="true"></dlistnumList>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import dlistnumList from '../components/dlistnumList'
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {}
  },
  components: {
    dlistnumList,
    HomeHeader,
  },
  methods: {
    onSubmit() {},
  },
}
</script>

<style scoped></style>
